(function () {
  'use strict';

  var WISH_KEY = 'fineri_wishlist_handles';

  function readCfg() {
    var el = document.getElementById('FineriStorefrontConfig');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return {};
    }
  }

  var c = readCfg();
  window.FINERI_STOREFRONT = c;

  function readPincodeRuntime() {
    var el = document.querySelector('script[id^="FineriPincodeRuntime-"]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return {};
    }
  }

  function applyPincodeUrlTemplate(template, pin) {
    var enc = encodeURIComponent(pin);
    return String(template)
      .replace(/\{\{\s*pincode\s*\}\}/gi, enc)
      .replace(/\{PINCODE\}/gi, enc)
      .replace(/\{pincode\}/gi, enc);
  }

  function computeEtaLabel(days, template) {
    var d = parseInt(days, 10);
    if (isNaN(d) || d < 1) d = 5;
    var date = new Date();
    date.setDate(date.getDate() + d);
    var formatted = date.toLocaleDateString(undefined, {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
    var tpl = template || '';
    if (tpl.indexOf('__DATE__') !== -1) {
      return tpl.split('__DATE__').join(formatted);
    }
    return tpl ? tpl.replace(/\{\{\s*date\s*\}\}/gi, formatted) : 'Estimated delivery by ' + formatted;
  }

  function deliverableMessage(po) {
    var pattern = c.pinDeliverableTo || '';
    if (!pattern) {
      return (c.pinAvailable || '').toString();
    }
    return pattern
      .split('__DISTRICT__')
      .join((po && po.District) || '')
      .split('__STATE__')
      .join((po && po.State) || '');
  }

  function formatEtaDate(d) {
    return d.toLocaleDateString(undefined, {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  }

  function applyEtaTemplate(template, dateStr) {
    var tpl = template || '';
    if (tpl.indexOf('__DATE__') !== -1) return tpl.split('__DATE__').join(dateStr);
    return tpl.replace(/\{\{\s*date\s*\}\}/gi, dateStr);
  }

  function handleCustomApiBody(body, rt, done) {
    if (!body || typeof body !== 'object') {
      done(c.pinLookupError || '', { ok: null });
      return;
    }
    if (body.ok === false || body.available === false || body.serviceable === false) {
      done(body.message || c.pinNotFound || '', { ok: false });
      return;
    }
    if (body.ok === true || body.available === true || body.serviceable === true) {
      var etaLabel = body.etaLabel || body.eta_text || body.delivery_estimate;
      if (!etaLabel && body.eta) {
        try {
          var dt = new Date(body.eta);
          if (!isNaN(dt.getTime())) {
            etaLabel = applyEtaTemplate(rt.estimatedTemplate, formatEtaDate(dt));
          }
        } catch (e) {}
      }
      if (!etaLabel && rt.estimatedTemplate) {
        etaLabel = computeEtaLabel(rt.deliveryDays, rt.estimatedTemplate);
      }
      done(body.message || c.pinAvailable || '', { ok: true, etaLabel: etaLabel });
      return;
    }
    done(c.pinLookupError || '', { ok: null });
  }

  function announce(msg) {
    if (!msg) return;
    var live = document.getElementById('FineriLiveRegion');
    if (!live) return;
    live.textContent = '';
    live.textContent = msg;
  }

  window.fineriAnnounce = announce;

  function getHandles() {
    try {
      var raw = localStorage.getItem(WISH_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.filter(Boolean) : [];
    } catch (e) {
      return [];
    }
  }

  function setHandles(handles) {
    var next = handles.filter(Boolean).slice(0, 200);
    try {
      localStorage.setItem(WISH_KEY, JSON.stringify(next));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('fineri:wishlist-updated'));
  }

  window.fineriWishlist = {
    getHandles: getHandles,
    setHandles: setHandles,
    has: function (handle) {
      return getHandles().indexOf(handle) !== -1;
    },
    toggle: function (handle) {
      if (!handle) return false;
      var h = getHandles();
      var i = h.indexOf(handle);
      if (i === -1) {
        h.unshift(handle);
        setHandles(h);
        return true;
      }
      h.splice(i, 1);
      setHandles(h);
      return false;
    },
    syncButtons: function () {
      document.querySelectorAll('[data-fineri-wishlist][data-product-handle]').forEach(syncWishlistButton);
      updateHeaderWishlistCount();
    },
  };

  function updateHeaderWishlistCount() {
    var n = getHandles().length;
    document.querySelectorAll('[data-fineri-wishlist-link]').forEach(function (link) {
      var sup = link.querySelector('[data-fineri-wishlist-count]');
      if (n > 0) {
        if (!sup) {
          sup = document.createElement('sup');
          sup.className = 'fineri-header__cart-count';
          sup.setAttribute('data-fineri-wishlist-count', '');
          link.appendChild(sup);
        }
        sup.hidden = false;
        sup.textContent = String(n);
      } else if (sup) {
        sup.remove();
      }
    });
  }

  function syncWishlistButton(btn) {
    var h = btn.getAttribute('data-product-handle');
    if (!h || !window.fineriWishlist) return;
    var on = window.fineriWishlist.has(h);
    btn.classList.toggle('fineri-pdp__wishlist--active', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  window.fineriPincodeCheck = function (code, cb) {
    if (typeof cb !== 'function') return;
    var normalized = String(code || '').replace(/\s/g, '');
    if (!normalized.length) {
      cb(c.pinEmpty || '', { ok: false });
      return;
    }
    if (!/^\d{6}$/.test(normalized)) {
      cb(c.pinInvalid || '', { ok: false });
      return;
    }

    var rt = readPincodeRuntime();
    var apiUrlTemplate = rt.apiUrlTemplate && String(rt.apiUrlTemplate).trim();
    var useIndiaPost = rt.useIndiaPost !== false;
    var deliveryDays = rt.deliveryDays != null ? rt.deliveryDays : 5;
    var estimatedTemplate = rt.estimatedTemplate || '';

    function done(msg, meta) {
      cb(msg || '', meta || {});
    }

    if (apiUrlTemplate) {
      var url = applyPincodeUrlTemplate(apiUrlTemplate, normalized);
      fetch(url, { method: 'GET', headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) {
          return r.text().then(function (text) {
            var body = {};
            try {
              body = text ? JSON.parse(text) : {};
            } catch (e) {}
            if (!r.ok) {
              done(body.message || c.pinNotFound || c.pinLookupError || '', { ok: false });
              return;
            }
            handleCustomApiBody(body, { deliveryDays: deliveryDays, estimatedTemplate: estimatedTemplate }, done);
          });
        })
        .catch(function () {
          done(c.pinLookupError || '', { ok: null });
        });
      return;
    }

    if (useIndiaPost) {
      fetch('https://api.postalpincode.in/pincode/' + encodeURIComponent(normalized), {
        method: 'GET',
        headers: { Accept: 'application/json' },
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          var row = Array.isArray(data) ? data[0] : data;
          if (row && row.Status === 'Success' && row.PostOffice && row.PostOffice.length) {
            var po = row.PostOffice[0];
            var msg = deliverableMessage(po);
            var etaLabel = computeEtaLabel(deliveryDays, estimatedTemplate);
            done(msg, { ok: true, etaLabel: etaLabel });
          } else {
            done(c.pinNotFound || c.pinInvalid || '', { ok: false });
          }
        })
        .catch(function () {
          done(c.pinLookupOffline || c.pinAvailable || '', { ok: null });
        });
      return;
    }

    done(c.pinAvailable || '', {
      ok: true,
      etaLabel: computeEtaLabel(deliveryDays, estimatedTemplate),
    });
  };

  document.addEventListener('fineri:wishlist', function (ev) {
    var d = ev.detail || {};
    var h = d.productHandle;
    if (!h) return;
    var added = window.fineriWishlist.toggle(h);
    window.fineriWishlist.syncButtons();
    var msg = added ? c.wishlistAdded || '' : c.wishlistRemoved || '';
    if (msg && typeof window.fineriAnnounce === 'function') window.fineriAnnounce(msg);
  });

  document.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest ? ev.target.closest('[data-fineri-wishlist][data-product-handle]') : null;
    if (!btn) return;
    ev.preventDefault();
    ev.stopPropagation();
    document.dispatchEvent(
      new CustomEvent('fineri:wishlist', {
        detail: {
          productHandle: btn.getAttribute('data-product-handle'),
        },
      })
    );
  });

  document.addEventListener('fineri:wishlist-updated', function () {
    window.fineriWishlist.syncButtons();
  });

  function storedReviewStats(productId) {
    if (!productId) return null;
    try {
      var all = JSON.parse(localStorage.getItem('fineri_product_reviews') || '{}');
      var arr = all[String(productId)];
      if (!Array.isArray(arr) || !arr.length) return null;
      var sum = 0;
      var n = 0;
      arr.forEach(function (r) {
        var rating = parseInt(r && r.rating, 10);
        if (!isNaN(rating)) {
          sum += rating;
          n += 1;
        }
      });
      if (!n) return null;
      var avg = Math.round((sum / n) * 10) / 10;
      var avgLabel = avg % 1 === 0 ? String(avg) : String(avg);
      return avgLabel + ' | ' + n;
    } catch (e) {
      return null;
    }
  }

  function syncCardRatings() {
    document.querySelectorAll('.fineri-plp-card[data-product-id]').forEach(function (card) {
      var id = card.getAttribute('data-product-id');
      var pill = card.querySelector('[data-fineri-card-rating]');
      if (!pill) return;
      var textEl = pill.querySelector('[data-fineri-card-rating-text]') || pill;
      var fromStore = storedReviewStats(id);
      if (fromStore) {
        if (textEl === pill) {
          var star = pill.querySelector('.fineri-plp-card__rating-star');
          pill.textContent = '';
          if (star) pill.appendChild(star);
          var span = document.createElement('span');
          span.setAttribute('data-fineri-card-rating-text', '');
          span.textContent = fromStore;
          pill.appendChild(span);
        } else {
          textEl.textContent = fromStore;
        }
        pill.hidden = false;
        pill.setAttribute('aria-label', fromStore);
        return;
      }
      var existing = textEl === pill ? '' : String(textEl.textContent || '').trim();
      pill.hidden = !existing;
    });
  }

  window.fineriSyncCardRatings = syncCardRatings;

  document.addEventListener('filters:applied', function () {
    window.fineriWishlist.syncButtons();
    syncCardRatings();
  });

  document.addEventListener('plp:page-appended', function () {
    window.fineriWishlist.syncButtons();
    syncCardRatings();
  });

  window.addEventListener('pageshow', function () {
    window.fineriWishlist.syncButtons();
    syncCardRatings();
  });

  window.addEventListener('storage', function (ev) {
    if (ev.key && ev.key !== WISH_KEY && ev.key !== 'fineri_product_reviews') return;
    window.fineriWishlist.syncButtons();
    syncCardRatings();
  });

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    window.fineriWishlist.syncButtons();
    syncCardRatings();
  });
})();

/**
 * Cart UI live-sync (classic script).
 * Unversioned ES-module CDN URLs can stay stale for a long time; this keeps bag
 * count + drawer updated after /cart/add|change|update regardless of module cache.
 */
(function () {
  'use strict';

  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.__fineriCartLiveSyncBound) return;
  window.__fineriCartLiveSyncBound = true;

  var syncTimer = null;
  var syncInFlight = null;

  function cfg() {
    return window.FINERI_STOREFRONT || {};
  }

  function cartJsUrl() {
    var paths = cfg().paths || {};
    return paths.cartJs || '/cart.js';
  }

  function sectionId() {
    var el = document.querySelector('[data-fineri-cart-drawer-root]');
    var fromDom = el && el.getAttribute('data-fineri-cart-render-id');
    return fromDom || cfg().cartDrawerSectionId || 'fineri-cart-drawer';
  }

  function updateHeaderCartCount(count) {
    var n = typeof count === 'number' ? count : 0;
    var links = document.querySelectorAll('[data-fineri-cart-link]');
    if (!links.length) return;
    links.forEach(function (link) {
      var sup = link.querySelector('.fineri-header__cart-count');
      if (n > 0) {
        if (!sup) {
          sup = document.createElement('sup');
          sup.className = 'fineri-header__cart-count';
          link.appendChild(sup);
        }
        sup.textContent = String(n);
      } else if (sup) {
        sup.remove();
      }
    });
  }

  function refreshCartCount() {
    return fetch(cartJsUrl(), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart_js');
        return r.json();
      })
      .then(function (cart) {
        updateHeaderCartCount(cart && typeof cart.item_count === 'number' ? cart.item_count : 0);
        return cart;
      })
      .catch(function () {
        return null;
      });
  }

  function replaceDrawerHtml(htmlString) {
    if (!htmlString || typeof htmlString !== 'string') return false;
    var cur = document.querySelector('[data-fineri-cart-drawer-root]');
    if (!cur) return false;
    var host = cur.closest('.shopify-section') || cur.closest('[id^="shopify-section-"]');
    if (!host) return false;
    var keepOpen = false;
    var curPanel = cur.querySelector('#FineriCartDrawerPanel');
    if (curPanel && !curPanel.hidden) keepOpen = true;
    var tpl = document.createElement('template');
    tpl.innerHTML = htmlString.trim();
    var incoming =
      tpl.content.querySelector('.shopify-section') ||
      tpl.content.querySelector('[id^="shopify-section-"]') ||
      tpl.content.firstElementChild;
    if (!incoming) return false;
    if (keepOpen) {
      var nextRoot =
        incoming.hasAttribute && incoming.hasAttribute('data-fineri-cart-drawer-root')
          ? incoming
          : incoming.querySelector('[data-fineri-cart-drawer-root]');
      if (nextRoot) {
        var ov = nextRoot.querySelector('.fineri-cart-drawer__overlay');
        var pan = nextRoot.querySelector('#FineriCartDrawerPanel');
        if (ov) ov.hidden = false;
        if (pan) pan.hidden = false;
      }
    }
    if (incoming.hasAttribute && incoming.hasAttribute('data-fineri-cart-drawer-root')) {
      cur.replaceWith(incoming);
      return true;
    }
    host.replaceWith(incoming);
    return true;
  }

  function refreshCartDrawer() {
    if (window.__fineriCartUiStamp && Date.now() - window.__fineriCartUiStamp < 1600) {
      return Promise.resolve(true);
    }
    var openPanel = document.querySelector('[data-fineri-cart-drawer-root] #FineriCartDrawerPanel');
    if (openPanel && !openPanel.hidden) return Promise.resolve(true);
    var id = sectionId();
    var url = '/?sections=' + encodeURIComponent(id);
    return fetch(url, {
      headers: { Accept: '*/*' },
      credentials: 'same-origin',
    })
      .then(function (r) {
        if (!r.ok) throw new Error('sections');
        return r.json();
      })
      .then(function (json) {
        var html =
          (json && typeof json[id] === 'string' && json[id]) ||
          (json && typeof json['fineri-cart-drawer'] === 'string' && json['fineri-cart-drawer']) ||
          '';
        if (!html && json) {
          for (var k in json) {
            if (
              Object.prototype.hasOwnProperty.call(json, k) &&
              typeof json[k] === 'string' &&
              json[k].indexOf('data-fineri-cart-drawer-root') !== -1
            ) {
              html = json[k];
              break;
            }
          }
        }
        if (!html) {
          return fetch('/?section_id=' + encodeURIComponent(id), { credentials: 'same-origin' }).then(
            function (r2) {
              if (!r2.ok) return false;
              return r2.text().then(function (text) {
                return replaceDrawerHtml(text);
              });
            }
          );
        }
        return replaceDrawerHtml(html);
      })
      .catch(function () {
        return false;
      });
  }

  function openFineriCartDrawer() {
    var root = document.querySelector('[data-fineri-cart-drawer-root]');
    if (!root) return;
    root.classList.remove('fineri-cart-drawer--gokwik-prefer');
    root.removeAttribute('data-fineri-cart-disabled');
    var overlay = root.querySelector('.fineri-cart-drawer__overlay');
    var panel = root.querySelector('#FineriCartDrawerPanel');
    if (overlay) overlay.hidden = false;
    if (panel) panel.hidden = false;
    document.documentElement.classList.add('fineri-cart-drawer-open');
    document.querySelectorAll('[data-fineri-cart-open]').forEach(function (t) {
      t.setAttribute('aria-expanded', 'true');
    });
  }

  function syncCartUi(options) {
    var opts = options || {};
    if (syncInFlight) return syncInFlight;
    syncInFlight = Promise.all([refreshCartCount(), refreshCartDrawer()])
      .then(function () {
        try {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'live-sync' } }));
        } catch (e) {}
        if (opts.openDrawer) openFineriCartDrawer();
      })
      .finally(function () {
        syncInFlight = null;
      });
    return syncInFlight;
  }

  function scheduleSync(options) {
    var opts = options || {};
    if (syncTimer) window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(function () {
      syncTimer = null;
      syncCartUi(opts);
    }, typeof opts.delay === 'number' ? opts.delay : 60);
  }

  function cartMutationUrl(url) {
    if (!url) return '';
    try {
      var u = String(url);
      if (u.indexOf('http') === 0) {
        u = new URL(u, window.location.origin).pathname;
      }
      return u;
    } catch (e) {
      return String(url);
    }
  }

  function isCartAddUrl(url) {
    var path = cartMutationUrl(url);
    return /\/cart\/add(\.js)?\/?$/.test(path) || path.indexOf('/cart/add') !== -1;
  }

  function isCartMutateUrl(url) {
    var path = cartMutationUrl(url);
    return /\/cart\/(add|change|update|clear)(\.js)?/.test(path);
  }

  if (typeof window.fetch === 'function') {
    var nativeFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = '';
      if (typeof input === 'string') url = input;
      else if (input && typeof input.url === 'string') url = input.url;
      var req = nativeFetch(input, init);
      if (!isCartMutateUrl(url)) return req;
      return req.then(function (res) {
        if (res && res.ok) {
          scheduleSync({ openDrawer: false, delay: 80 });
        }
        return res;
      });
    };
  }

  if (window.XMLHttpRequest && !window.XMLHttpRequest.__fineriStorefrontPatched) {
    var XHR = window.XMLHttpRequest;
    var xhrOpen = XHR.prototype.open;
    var xhrSend = XHR.prototype.send;
    XHR.prototype.open = function (method, url) {
      this.__fineriUrl = url;
      return xhrOpen.apply(this, arguments);
    };
    XHR.prototype.send = function () {
      var xhr = this;
      var url = xhr.__fineriUrl || '';
      if (isCartMutateUrl(url)) {
        xhr.addEventListener('load', function () {
          if (xhr.status >= 200 && xhr.status < 300) {
            scheduleSync({ openDrawer: false, delay: 80 });
          }
        });
      }
      return xhrSend.apply(this, arguments);
    };
    XHR.__fineriStorefrontPatched = true;
  }

  function readBadgeCount() {
    var sup = document.querySelector('[data-fineri-cart-link] .fineri-header__cart-count');
    if (!sup) return 0;
    var n = parseInt(sup.textContent, 10);
    return isNaN(n) ? 0 : n;
  }

  function pollAfterAdd() {
    var before = readBadgeCount();
    window.setTimeout(function () {
      if (readBadgeCount() > before) return;
      if (window.__fineriCartUiStamp && Date.now() - window.__fineriCartUiStamp < 1600) return;
      syncCartUi({ openDrawer: false });
    }, 800);
  }

  document.addEventListener(
    'click',
    function (ev) {
      var btn =
        ev.target && ev.target.closest
          ? ev.target.closest(
              '[data-add-to-bag], [data-fineri-sticky-atc-submit], .fineri-plp-card__atc-btn, .fineri-quick-view__submit[data-qv-submit-mode="cart"]'
            )
          : null;
      if (!btn || btn.disabled) return;
      pollAfterAdd();
    },
    true
  );

  document.addEventListener(
    'submit',
    function (ev) {
      var form = ev.target;
      if (!form || form.nodeName !== 'FORM') return;
      if (
        !(
          form.classList.contains('fineri-pdp__form') ||
          form.classList.contains('fineri-plp-card__atc-form') ||
          form.classList.contains('fineri-quick-view__form')
        )
      ) {
        return;
      }
      pollAfterAdd();
    },
    true
  );

  document.addEventListener('cart:added', function () {
    scheduleSync({ openDrawer: false, delay: 40 });
  });

  window.fineriRefreshCartCount = function () {
    return refreshCartCount();
  };
  window.fineriSyncCartUi = function (openDrawer) {
    return syncCartUi({ openDrawer: !!openDrawer });
  };
})();
